import { FAILURE, REQUEST, SUCCESS } from '@/modules/b2b/services/libs/state';

export const MUTATIONS = {
  // get list customer
  GET_LIST_CUSTOMER_CARD_REQUEST: 'GET_LIST_CUSTOMER_CARD_REQUEST',
  GET_LIST_CUSTOMER_CARD_SUCCESS: 'GET_LIST_CUSTOMER_CARD_SUCCESS',
  GET_LIST_CUSTOMER_CARD_FAILURE: 'GET_LIST_CUSTOMER_CARD_FAILURE',

  // get default card
  GET_DEFAULT_CARD_REQUEST: 'GET_DEFAULT_CARD_REQUEST',
  GET_DEFAULT_CARD_SUCCESS: 'GET_DEFAULT_CARD_SUCCESS',
  GET_DEFAULT_CARD_FAILURE: 'GET_DEFAULT_CARD_FAILURE',

  // remove card
  REMOVE_CARD_REQUEST: 'REMOVE_CARD_REQUEST',
  REMOVE_CARD_SUCCESS: 'REMOVE_CARD_SUCCESS',
  REMOVE_CARD_FAILURE: 'REMOVE_CARD_FAILURE',

  // add stripe card
  ADD_STRIPE_CARD_REQUEST: 'ADD_STRIPE_CARD_REQUEST',
  ADD_STRIPE_CARD_SUCCESS: 'ADD_STRIPE_CARD_SUCCESS',
  ADD_STRIPE_CARD_FAILURE: 'ADD_STRIPE_CARD_FAILURE',

  // set default card
  SET_DEFAULT_CARD_REQUEST: 'SET_DEFAULT_CARD_REQUEST',
  SET_DEFAULT_CARD_SUCCESS: 'SET_DEFAULT_CARD_SUCCESS',
  SET_DEFAULT_CARD_FAILURE: 'SET_DEFAULT_CARD_FAILURE',

  //get list nets card
  GET_LIST_NETS_CARD_SUCCESS: 'GET_LIST_NETS_CARD_SUCCESS',
  GET_LIST_NETS_CARD_FAILURE: 'GET_LIST_NETS_CARD_FAILURE',

  //get nets list merchant
  GET_NETS_LIST_MERCHANT_SUCCESS: 'GET_NETS_LIST_MERCHANT_SUCCESS',
  GET_NETS_LIST_MERCHANT_FAILURE: 'GET_NETS_LIST_MERCHANT_FAILURE',

  //action nets list merchant
  REMOVE_NETS_CARD_SUCCESS: 'REMOVE_NETS_CARD_SUCCESS',
  REMOVE_NETS_CARD_FAILURE: 'REMOVE_NETS_CARD_FAILURE',
  SET_NETS_CARD_DEFAULT_SUCCESS: 'SET_NETS_CARD_DEFAULT_SUCCESS',
  SET_NETS_CARD_DEFAULT_FAILURE: 'SET_NETS_CARD_DEFAULT_FAILURE',
  SET_STRIPE_ID: 'SET_STRIPE_ID',
  GET_LIST_CARD_BY_STRIPE_ID_REQUEST: 'GET_LIST_CARD_BY_STRIPE_ID_REQUEST',
  GET_LIST_CARD_BY_STRIPE_ID_SUCCESS: 'GET_LIST_CARD_BY_STRIPE_ID_SUCCESS',
  GET_LIST_CARD_BY_STRIPE_ID_FAILURE: 'GET_LIST_CARD_BY_STRIPE_ID_FAILURE',

  // action get invoices by customer
  GET_CUSTOMER_INVOICES_REQUEST: 'GET_CUSTOMER_INVOICES_REQUEST',
  GET_CUSTOMER_INVOICES_SUCCESS: 'GET_CUSTOMER_INVOICES_SUCCESS',
  GET_CUSTOMER_INVOICES_FAILURE: 'GET_CUSTOMER_INVOICES_FAILURE',
  UPDATE_QUERY_PARAMS_GET_CUSTOMER_INVOICE: 'UPDATE_QUERY_PARAMS_GET_CUSTOMER_INVOICE',

  // reset error and status back to default value
  RESET_STATUS_ERROR: 'RESET_STATUS_ERROR',

  // create payment
  CREATE_PAYMENT_REQUEST: 'CREATE_PAYMENT_REQUEST',
  CREATE_PAYMENT_SUCCESS: 'CREATE_PAYMENT_SUCCESS',
  CREATE_PAYMENT_FAILURE: 'CREATE_PAYMENT_FAILURE',

  // create cash deposit payment
  CREATE_CASH_PAYMENT_REQUEST: 'CREATE_CASH_PAYMENT_REQUEST',
  CREATE_CASH_PAYMENT_SUCCESS: 'CREATE_CASH_PAYMENT_SUCCESS',
  CREATE_CASH_PAYMENT_FAILURE: 'CREATE_CASH_PAYMENT_FAILURE',

  CREATE_AUTOMATIC_BATCH_PAYMENTS_REQUEST: 'CREATE_AUTOMATIC_BATCH_PAYMENTS_REQUEST',
  CREATE_AUTOMATIC_BATCH_PAYMENTS_SUCCESS: 'CREATE_AUTOMATIC_BATCH_PAYMENTS_SUCCESS',
  CREATE_AUTOMATIC_BATCH_PAYMENTS_FAILURE: 'CREATE_AUTOMATIC_BATCH_PAYMENTS_FAILURE',

  // get xero customer info
  GET_XERO_CUSTOMER_REQUEST: 'GET_XERO_CUSTOMER_REQUEST',
  GET_XERO_CUSTOMER_SUCCESS: 'GET_XERO_CUSTOMER_SUCCESS',
  GET_XERO_CUSTOMER_FAILURE: 'GET_XERO_CUSTOMER_FAILURE',

  // get xero customer info
  GET_TOTAL_UNPAID_INVOICES_REQUEST: 'GET_TOTAL_UNPAID_INVOICES_REQUEST',
  GET_TOTAL_UNPAID_INVOICES_SUCCESS: 'GET_TOTAL_UNPAID_INVOICES_SUCCESS',
  GET_TOTAL_UNPAID_INVOICES_FAILURE: 'GET_TOTAL_UNPAID_INVOICES_FAILURE',

  SET_SELECTED_PAYMENT_INVOICES: 'SET_SELECTED_PAYMENT_INVOICES',
  REMOVE_SELECTED_PAYMENT_INVOICES: 'REMOVE_SELECTED_PAYMENT_INVOICES',

  CHECK_IS_FINANCE_MODULE_ENABLED_SUCCESS: 'CHECK_IS_FINANCE_MODULE_ENABLED_SUCCESS',
  CHECK_IS_FINANCE_MODULE_ENABLED_FAILURE: 'CHECK_IS_FINANCE_MODULE_ENABLED_FAILURE',

  GET_PAYMENT_HISTORY_REQUEST: 'GET_PAYMENT_HISTORY_REQUEST',
  GET_PAYMENT_HISTORY_SUCCESS: 'GET_PAYMENT_HISTORY_SUCCESS',
  GET_PAYMENT_HISTORY_FAILED: 'GET_PAYMENT_HISTORY_FAILED',

  CANCEL_MANUAL_PAYMENT_REQUEST: 'CANCEL_MANUAL_PAYMENT_REQUEST',
  CANCEL_MANUAL_PAYMENT_SUCCESS: 'CANCEL_MANUAL_PAYMENT_SUCCESS',
  CANCEL_MANUAL_PAYMENT_FAILED: 'CANCEL_MANUAL_PAYMENT_FAILED',
  END_CANCEL_MANUAL_PAYMENT: 'END_CANCEL_MANUAL_PAYMENT',

  CANCEL_PREPAYMENT_PAYMENT_REQUEST: 'CANCEL_PREPAYMENT_PAYMENT_REQUEST',
  CANCEL_PREPAYMENT_PAYMENT_SUCCESS: 'CANCEL_PREPAYMENT_PAYMENT_SUCCESS',
  CANCEL_PREPAYMENT_PAYMENT_FAILED: 'CANCEL_PREPAYMENT_PAYMENT_FAILED',
  END_CANCEL_PREPAYMENT: 'END_CANCEL_PREPAYMENT',

  CANCEL_STRIPE_PAYMENT_REQUEST: 'CANCEL_STRIPE_PAYMENT_REQUEST',
  CANCEL_STRIPE_PAYMENT_SUCCESS: 'CANCEL_STRIPE_PAYMENT_SUCCESS',
  CANCEL_STRIPE_PAYMENT_FAILED: 'CANCEL_STRIPE_PAYMENT_FAILED',
  END_CANCEL_STRIPE_PAYMENT: 'END_CANCEL_STRIPE_PAYMENT',

  SET_IS_ENTER_STRIPE_URL: 'SET_IS_ENTER_STRIPE_URL'
};

export default {
  // get list customer card
  [MUTATIONS.GET_LIST_CUSTOMER_CARD_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.GET_LIST_CUSTOMER_CARD_SUCCESS](state, listCustomerCard) {
    SUCCESS(state);
    state.listCustomerCard = listCustomerCard;
  },
  [MUTATIONS.GET_LIST_CUSTOMER_CARD_FAILURE](state, error) {
    FAILURE(state, error);
  },

  // get default card
  [MUTATIONS.GET_DEFAULT_CARD_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.GET_DEFAULT_CARD_SUCCESS](state, defaultCardId) {
    SUCCESS(state);
    state.defaultCardId = defaultCardId;
  },
  [MUTATIONS.GET_DEFAULT_CARD_FAILURE](state, error) {
    FAILURE(state, error);
  },

  // remove card
  [MUTATIONS.REMOVE_CARD_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.REMOVE_CARD_SUCCESS](state, removeStripeCard) {
    SUCCESS(state);
    state.removeStripeCard = removeStripeCard;
  },
  [MUTATIONS.REMOVE_CARD_FAILURE](state, error) {
    FAILURE(state, error);
  },

  // add stripe card
  [MUTATIONS.ADD_STRIPE_CARD_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.ADD_STRIPE_CARD_SUCCESS](state, addStripeCard) {
    SUCCESS(state);
    state.addStripeCard = addStripeCard;
  },
  [MUTATIONS.ADD_STRIPE_CARD_FAILURE](state, error) {
    FAILURE(state, error);
  },

  // set default card
  [MUTATIONS.SET_DEFAULT_CARD_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.SET_DEFAULT_CARD_SUCCESS](state, defaultCardId) {
    SUCCESS(state);
    state.defaultCardId = defaultCardId;
  },
  [MUTATIONS.SET_DEFAULT_CARD_FAILURE](state, error) {
    FAILURE(state, error);
  },
  //get list nets card
  [MUTATIONS.GET_LIST_NETS_CARD_SUCCESS](state, payload) {
    SUCCESS(state);
    state.listNetsCard = payload;
  },
  [MUTATIONS.GET_LIST_NETS_CARD_FAILURE](state, error) {
    FAILURE(state, error);
  },

  //get nets list merchant
  [MUTATIONS.GET_NETS_LIST_MERCHANT_SUCCESS](state, payload) {
    SUCCESS(state);
    state.listNetsMerchant = payload;
  },
  [MUTATIONS.GET_NETS_LIST_MERCHANT_FAILURE](state) {
    FAILURE(state);
  },
  [MUTATIONS.REMOVE_NETS_CARD_SUCCESS](state) {
    SUCCESS(state);
  },
  [MUTATIONS.REMOVE_NETS_CARD_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.SET_NETS_CARD_DEFAULT_SUCCESS](state) {
    SUCCESS(state);
  },
  [MUTATIONS.SET_NETS_CARD_DEFAULT_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.SET_STRIPE_ID](state, payload) {
    state.stripeId = payload;
  },
  [MUTATIONS.GET_LIST_CARD_BY_STRIPE_ID_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.GET_LIST_CARD_BY_STRIPE_ID_SUCCESS](state, payload) {
    SUCCESS(state);
    state.listCardByStripeId = payload;
  },
  [MUTATIONS.GET_LIST_CARD_BY_STRIPE_ID_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.GET_CUSTOMER_INVOICES_REQUEST](state, isLoadMore) {
    REQUEST(state);
    state.isLoadMore = isLoadMore;
  },
  [MUTATIONS.GET_CUSTOMER_INVOICES_SUCCESS](state, { listInvoices }) {
    SUCCESS(state);
    if (state.isLoadMore) {
      const invoices = [...state.listInvoices.invoices, ...listInvoices.invoices];
      state.listInvoices = {
        ...listInvoices,
        invoices
      };
    } else {
      state.listInvoices = listInvoices;
    }
  },
  [MUTATIONS.GET_CUSTOMER_INVOICES_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.UPDATE_QUERY_PARAMS_GET_CUSTOMER_INVOICE](state, { paramsListInvoices }) {
    state.paramsListInvoices = {
      ...state.paramsListInvoices,
      ...paramsListInvoices
    };
  },
  [MUTATIONS.RESET_STATUS_ERROR](state) {
    state.status = true;
    state.error = null;
  },
  [MUTATIONS.CREATE_PAYMENT_REQUEST](state, { paramsCreatePayment }) {
    state.paramsCreatePayment = {
      ...state.paramsCreatePayment,
      ...paramsCreatePayment
    };
  },
  [MUTATIONS.CREATE_PAYMENT_SUCCESS](state, { paymentSummary }) {
    SUCCESS(state);
    state.paymentSummary = paymentSummary;
  },
  [MUTATIONS.CREATE_PAYMENT_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.CREATE_CASH_PAYMENT_REQUEST](state, { paramsCreatePayment }) {
    state.paramsCreatePayment = {
      ...state.paramsCreatePayment,
      ...paramsCreatePayment
    };
  },
  [MUTATIONS.CREATE_CASH_PAYMENT_SUCCESS](state, { paymentSummary }) {
    SUCCESS(state);
    state.paymentSummary = paymentSummary;
  },
  [MUTATIONS.CREATE_CASH_PAYMENT_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.CREATE_AUTOMATIC_BATCH_PAYMENTS_REQUEST](state, { paramsCreatePayment }) {
    state.paramsCreatePayment = {
      ...state.paramsCreatePayment,
      ...paramsCreatePayment
    };
  },
  [MUTATIONS.CREATE_AUTOMATIC_BATCH_PAYMENTS_SUCCESS](state, { paymentSummary }) {
    SUCCESS(state);
    state.paymentSummary = paymentSummary;
  },
  [MUTATIONS.CREATE_AUTOMATIC_BATCH_PAYMENTS_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.GET_XERO_CUSTOMER_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.GET_XERO_CUSTOMER_SUCCESS](state, payload) {
    SUCCESS(state);
    state.xeroCustomer = payload;
  },
  [MUTATIONS.GET_XERO_CUSTOMER_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.GET_TOTAL_UNPAID_INVOICES_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.GET_TOTAL_UNPAID_INVOICES_SUCCESS](state, payload) {
    SUCCESS(state);
    state.totalUnpaidInvoices = payload.total_unpaid_invoices;
    state.totalOverdueInvoices = payload.total_overdue_invoices;
  },
  [MUTATIONS.GET_TOTAL_UNPAID_INVOICES_FAILURE](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.SET_SELECTED_PAYMENT_INVOICES](state, payload) {
    state.loading = true;
    state.selectedPaymentInvoices = payload;
    setTimeout(() => {
      state.loading = false;
    }, 500);
  },
  [MUTATIONS.REMOVE_SELECTED_PAYMENT_INVOICES](state) {
    state.selectedPaymentInvoices = null;
  },
  [MUTATIONS.CHECK_IS_FINANCE_MODULE_ENABLED_SUCCESS](state, params) {
    SUCCESS(state);
    state.isFinanceModuleEnabled = params;
  },
  [MUTATIONS.CHECK_IS_FINANCE_MODULE_ENABLED_FAILURE](state, error) {
    FAILURE(state, error);
  },

  [MUTATIONS.GET_PAYMENT_HISTORY_REQUEST](state) {
    REQUEST(state);
  },
  [MUTATIONS.GET_PAYMENT_HISTORY_SUCCESS](state, payload) {
    SUCCESS(state);
    state.paymentHistory = payload;
  },
  [MUTATIONS.GET_PAYMENT_HISTORY_FAILED](state, error) {
    FAILURE(state, error);
  },

  [MUTATIONS.CANCEL_MANUAL_PAYMENT_REQUEST](state) {
    REQUEST(state);
    state.isLoadingCancellingPayment = true;
  },
  [MUTATIONS.CANCEL_MANUAL_PAYMENT_SUCCESS](state, { cancelManualPayment }) {
    SUCCESS(state);
    state.cancelManualPayment = cancelManualPayment;
  },
  [MUTATIONS.CANCEL_MANUAL_PAYMENT_FAILED](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.END_CANCEL_MANUAL_PAYMENT](state) {
    state.isLoadingCancellingPayment = false;
  },

  [MUTATIONS.CANCEL_PREPAYMENT_PAYMENT_REQUEST](state) {
    REQUEST(state);
    state.isLoadingCancellingPayment = true;
  },
  [MUTATIONS.CANCEL_PREPAYMENT_PAYMENT_SUCCESS](state, { cancelPrepayment }) {
    SUCCESS(state);
    state.cancelPrepayment = cancelPrepayment;
  },
  [MUTATIONS.CANCEL_PREPAYMENT_PAYMENT_FAILED](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.END_CANCEL_PREPAYMENT](state) {
    state.isLoadingCancellingPayment = false;
  },

  [MUTATIONS.CANCEL_STRIPE_PAYMENT_REQUEST](state) {
    REQUEST(state);
    state.isLoadingCancellingPayment = true;
  },
  [MUTATIONS.CANCEL_STRIPE_PAYMENT_SUCCESS](state, { cancelStripePaymentIntent }) {
    SUCCESS(state);
    state.cancelStripePaymentIntent = cancelStripePaymentIntent;
  },
  [MUTATIONS.CANCEL_STRIPE_PAYMENT_FAILED](state, error) {
    FAILURE(state, error);
  },
  [MUTATIONS.END_CANCEL_STRIPE_PAYMENT](state) {
    state.isLoadingCancellingPayment = false;
  },
  [MUTATIONS.SET_IS_ENTER_STRIPE_URL](state, boolean) {
    state.isEnterStripeUrl = boolean;
  }
};
